/// <reference path="DOMAttached.js" />
/// <reference path="../../../gulp/node_modules/soundmanager2/script/soundmanager2-nodebug.js" />

class LegacyGameHeader extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.isShown = options.isShown;
		this.toggleFeedbackSoundUrl = options.toggleFeedbackSoundUrl;
		this.toggleGameContentReadingUrl = options.toggleGameContentReadingUrl;
		window.LegacyGameHeaderInstance = this;

		const isHeaderFound = this.el.querySelector(".mia-" + options.className);

		if (isHeaderFound) {
			const app = window.createVueApplication('legacy-game-header');
			app.mount(this.el);
		}

		if (this.isShown) {
			// Sound toggles are shown only when the more-options menu is opened, and after it is closed, the element is deleted.
			// GameSettingsMenu.vue calls onGameSettingsMenuOpen() directly (via the global
			// LegacyGameHeaderInstance) once the menu's contents have actually rendered.
			waitForElementToBePresent(".mia-GameSettingsMenu").then((element) => {
				this.onGameSettingsMenuOpen = () => this.onGameSettingsMenuClick(element);
			});
		}
	}

	onGameSettingsMenuClick(element) {
		var lessonSoundToggleButtonElement = element.querySelector(".mia-lessonSoundToggleButton .mia-ToggleButton-input");
		var readAloudToggleButtonElement = element.querySelector(".mia-readAloudToggleButton .mia-ToggleButton-input");

		if (lessonSoundToggleButtonElement) {
			this.initializeLessonSoundToggleButton(lessonSoundToggleButtonElement);
		}
		if (readAloudToggleButtonElement) {
			this.initializeReadAloudToggleButton(readAloudToggleButtonElement);
		}
	}

	onLessonSoundToggleButtonChange() {
		axios(this.toggleFeedbackSoundUrl, {
			method: 'get'
		}).then((response) => {
			this.onLessonSoundToggleButtonChangeSuccess();
		});
	}

	onLessonSoundToggleButtonChangeSuccess() {
		if (GenericSoundsInstance !== undefined && GenericSoundsInstance.playFeedbackSound !== undefined) {
			GenericSoundsInstance.playFeedbackSound = !GenericSoundsInstance.playFeedbackSound;
			if (GenericSoundsInstance.playFeedbackSound) {
				if (window.PlayFeedbackSound != null) {
					window.PlayFeedbackSound = true;
				}
			} else {
				soundManager.stop('intro');
				soundManager.stop('theme');
				if (window.PlayFeedbackSound != null) {
					window.PlayFeedbackSound = false;
				}
			}
		}
	}

	onReadAloudToggleButtonChange() {
		axios(this.toggleGameContentReadingUrl, {
			method: 'get'
		}).then((response) => {
			this.onReadAloudToggleButtonSuccess();
		});
	}

	onReadAloudToggleButtonSuccess() {
		if (GamesTextToSpeechInstance !== null && GamesTextToSpeechInstance !== undefined) {
			if (GamesTextToSpeechInstance.isEnabled) {
				GamesTextToSpeechInstance.turnOffTextToSpeech();
			} else {
				GamesTextToSpeechInstance.turnOnTextToSpeech();
				GamesQuizInstance.createAndReadAllTextToSpeech();
			}
		}
	}

	initializeLessonSoundToggleButton(element) {
		this.safeObserve(element, 'click', this.onLessonSoundToggleButtonChange.bind(this));
	}

	initializeReadAloudToggleButton(element) {
		this.safeObserve(element, 'click', this.onReadAloudToggleButtonChange.bind(this));
	}
}
